import React from 'react';
import classNames from 'classnames';

// TODO Review use of this class by reading https://lets-do-this.atlassian.net/browse/LDS-42
import { GLOBAL_FORM_STYLES_CLASS } from '@/globalClasses';

import Overlay from '../Overlay';
import ErrorMessage from '../ErrorMessage';
import * as styles from './styles.module.css';
import { validateFieldParams } from '../Validator';
import { FieldParams, ErrorMessageParams } from '../Types';

const Field = (params: FieldParams): JSX.Element => {
  validateFieldParams(params);
  const { value, setValue, title, error, overlay, hidden } = params;
  return (
    <div className={classNames(styles.field, GLOBAL_FORM_STYLES_CLASS)}>
      <div
        className={classNames(styles.headerText, {
          [`${styles.error}`]: !!error,
        })}
      >
        {title}
      </div>
      <input
        className={classNames(styles.inputField, {
          [`${styles.errorInput}`]: !!error,
        })}
        type={hidden ? 'password' : 'text'}
        onChange={(event) => setValue(event.target.value)}
        value={value || ''}
      />
      {overlay && Overlay(overlay)}
      {params.error && ErrorMessage(params as ErrorMessageParams)}
    </div>
  );
};

export default Field;
